import React, { useState, useEffect, useMemo } from "react";
import "./styles.css";
import actividadMaxIcon from "../../../static/img/actividadMaxIcon.svg";
import { useNavigate } from "react-router-dom";
import Footer from "../footer/footer.js";
import { getUserActivity } from "../../../services/deportistaApi";
import { getUserId } from "../../../services/utilsApi";
import tickBlanco from "../../../static/img/tickActividad.svg";
import LoadingScreen from "../../../static/assets/loadingScreen/loadingScreen";
import CuadroTexto from "../../../static/assets/cuadroTexto/cuadroTexto";

const Actividad = () => {
  const [selectedDays, setSelectedDays] = useState({});
  const [totalEntrenamientos, setTotalEntrenamientos] = useState();
  const [bloquesHoy, setBloquesHoy] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const daysOfWeek = useMemo(
    () => [
      { id: "L", label: "L", name: "Lunes" },
      { id: "M1", label: "M", name: "Martes" },
      { id: "M2", label: "M", name: "Miércoles" },
      { id: "J", label: "J", name: "Jueves" },
      { id: "V", label: "V", name: "Viernes" },
      { id: "S", label: "S", name: "Sábado" },
      { id: "D", label: "D", name: "Domingo" },
    ],
    []
  );

  const bloquesHoyOrdenados = useMemo(
    () => bloquesHoy.sort((a,b) => a.id_bloque_deportista - b.id_bloque_deportista),[bloquesHoy]
  )

  useEffect(() => {
    const fetchActivity = async () => {
      try {
        setLoading(true);
        const { data: userIdResponse } = await getUserId();
        const uid = userIdResponse.user_id;
        const { data: activityResponse } = await getUserActivity(uid);

        if (activityResponse.success) {
          setTotalEntrenamientos(activityResponse.total_completados);
          setBloquesHoy(activityResponse.bloques_hoy);

          const updatedSelectedDays = daysOfWeek.reduce((acc, day) => {
            acc[day.id] = activityResponse.dias_con_ejercicios.includes(day.id);
            return acc;
          }, {});
          setSelectedDays(updatedSelectedDays);
        } else {
          throw new Error("Error al obtener los datos de actividad.");
        }
      } catch (error) {
        setErrorMessage("Error al cargar la actividad del usuario.");
      } finally {
        setLoading(false);
      }
    };

    fetchActivity();
  }, [daysOfWeek]);

  const renderBloqueHoy = (bloque, index) => {
    const isCompleted = bloque.completed;

    return (
      <div key={index} className="bloque-item" data-testid={`bloque-container-${index}`}>
        <div className={`actividad-icon-container ${isCompleted ? "complete" : ""}`}>
          <div className={`actividad-ellipse ${isCompleted ? "complete" : ""}`}>
            {isCompleted ? (
              <img src={tickBlanco} alt="Completed" />
            ) : (
              <span className="entrenamiento-ellipse-text" />
            )}
          </div>
        </div>
        <div>
          <div className="actividad-bloque-title">{bloque.nombre}</div>
        </div>
      </div>
    );
  };

  if (loading) {
    return <div role="alert" data-testid="loading-screen"><LoadingScreen /></div>;
  }  

  return (
    <>
      {errorMessage && (
        <CuadroTexto
          message={errorMessage}
          onAccept={() => setErrorMessage("")}
          showCancel={false}
        />
      )}

      <div className="actividad">
        <h2 className="actividad-title">Actividad</h2>

        <div className="actividad-overlap">
          <div className="actividad-stats-bg"></div>
          <div className="actividad-stats-circle" />
          <div className="actividad-stats-inner-circle"></div>
            <h1 className="actividad-stats-number">{totalEntrenamientos}</h1>
            <p className="actividad-stats-label">Entrenamientos completados</p>
        </div>

        <div className="actividad-days-container">
          <h3 className="actividad-days-title">Entrenamientos esta semana</h3>
          <div className="actividad-days-grid">
            {daysOfWeek.map((day) => (
              <div
                key={day.id}
                className={`actividad-day-btn${selectedDays[day.id] ? "-selected" : ""}`}
                aria-label={`Día de entrenamiento ${day.name}`}
              >
                <div className={selectedDays[day.id] ? "overlap-6" : "overlap-7"}>
                  <span className="actividad-day-label">{day.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>


        <button
          className="actividad-max-container"
          onClick={() => navigate('/dashboard/maximos')}
          aria-label="Ver Mis Máximos"
        >
          <div className="actividad-max-btn">Mis máximos</div>
          <img className="actividad-max-icon" src={actividadMaxIcon} alt="Siguiente" />
        </button>

        <div className="actividad-bloques-card">
          <span className="actividad-bloques-title">Entrenamiento de Hoy</span>
          <div className="bloques-hoy-list">
            {bloquesHoyOrdenados.map(renderBloqueHoy)}
          </div>
        </div>

          <button
            className="actividad-entrenamiento-btn"
            onClick={() => navigate('/entrenamiento')}
            aria-label="Mi entrenamiento"
          >
            <span className="span">Mi entrenamiento</span>
          </button>

      </div>

      <Footer activeScreen="actividad" />
    </>
  );
};

export default Actividad;
